import { render, staticRenderFns } from "./templateGallery.vue?vue&type=template&id=2b2afb4e&"
import script from "./templateGallery.vue?vue&type=script&lang=js&"
export * from "./templateGallery.vue?vue&type=script&lang=js&"
import style0 from "./templateGallery.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports